<template>
    <div class="step-three">
        <div class="step-three__wrapper">
            <ElForm
                class="step-three__form form"
                ref="propertyFormRef"
                :rules="rules"
                :model="propertyForm"
            >
                <section class="step-three__form-section">
                    <h2 class="step-three__form-section-title">
                        Личные данные
                    </h2>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="fio"
                        >
                            <ElAutocomplete
                                v-model="propertyForm.fio"
                                placeholder="ФИО"
                                :fetch-suggestions="fetchFioSuggestions"
                                :popper-append-to-body="false"
                            >
                                <template #prefix>
                                    ФИО
                                </template>
                            </ElAutocomplete>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item form__item--col">
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="birthDate"
                        >
                            <ElDatePicker
                                v-model="propertyForm.birthDate"
                                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                                ref="birthPicker"
                                type="date"
                                placeholder="дд.мм.гггг"
                                :default-value="''"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="{ firstDayOfWeek: 1 }"
                                disabled
                            />
                            <span class="form__label">Дата рождения</span>
                        </ElFormItem>
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="gender"
                        >
                            <ElInput
                                v-model="propertyForm.gender"
                                placeholder="Пол"
                                disabled
                            >
                                <template #prefix>
                                    Пол
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>

                    <div class="step-three__item form__item form__item--col">
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="height"
                        >
                            <ElInput
                                v-model="propertyForm.height"
                                placeholder="Рост, см"
                                type="number"
                            >
                                <template #prefix>
                                    Рост, см
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="weight"
                        >
                            <ElInput
                                v-model="propertyForm.weight"
                                placeholder="Вес, кг"
                                type="number"
                            >
                                <template #prefix>
                                    Вес, кг
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item form__item--col">
                        <ElFormItem
                            class="form__col form__col--half"
                            prop="phone"
                        >
                            <ElInput
                                v-model="propertyForm.phone"
                                placeholder="Номер телефона"
                                v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
                            >
                                <template #prefix>
                                    Телефон
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                        <ElFormItem
                            class="form__col form__col--half"
                            prop="email"
                        >
                            <ElInput
                                v-model="propertyForm.email"
                                type="email"
                                placeholder="E-mail">
                                <template #prefix>
                                    E-mail
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                </section>
                <section class="step-three__form-section">
                    <h2 class="step-three__form-section-title">
                        Паспортные данные
                    </h2>
                    <div class="step-three__item form__item form__item--col">
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="passportNumber"
                        >
                            <ElInput
                                v-model="propertyForm.passportNumber"
                                placeholder="Серия и номер паспорта"
                                v-mask="{regex: '^[0-9]${2} [0-9]${2} [0-9]${6}'}"
                            >
                                <template #prefix>
                                    Серия и номер паспорта
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                        <ElFormItem
                            class="step-three__item-col form__col form__col--half"
                            prop="passportDate"
                        >
                            <ElDatePicker
                                v-model="propertyForm.passportDate"
                                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                                type="date"
                                placeholder="Дата выдачи"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="{ disabledDate: (time) => getDisabledPassportDate(time), firstDayOfWeek: 1 }"
                            />
                            <span class="form__label">Дата выдачи</span>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="departmentCode"
                        >
                            <ElAutocomplete class="form__item"
                                            v-model="propertyForm.departmentCode"
                                            :fetch-suggestions="fetchPassportCodeSuggestions"
                                            placeholder="Код подразделения"
                                            :trigger-on-focus="false"
                                            value-key="code"
                                            @select="handleSelectIssuedByCode"
                                            v-mask="'###-###'"
                            >
                                <template #default="{ item }">
                                    <span><b>{{ item?.code ?? '' }}</b> - {{ item?.name ?? '' }}</span>
                                </template>
                            </ElAutocomplete>
                            <template #prefix>
                                Код подразделения
                            </template>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="issuedBy"
                        >
                            <ElAutocomplete class="form__item"
                                            v-model="propertyForm.issuedBy"
                                            :fetch-suggestions="fetchPassportCodeSuggestions"
                                            placeholder="Кем выдан"
                                            :trigger-on-focus="false"
                                            value-key="name"
                                            @select="handleSelectIssuedByCode"
                            >
                                <template #default="{ item }">
                                    <span><b>{{ item?.name ?? '' }}</b> - {{ item?.code ?? '' }}</span>
                                </template>
                            </ElAutocomplete>
                            <template #prefix>
                                Кем выдан
                            </template>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="registrationAddress"
                        >
                            <ElAutocomplete class="form__item"
                                            v-model="propertyForm.registrationAddress"
                                            :fetch-suggestions="fetchAddressSuggestions"
                                            placeholder="Адрес регистрации"
                                            :trigger-on-focus="false"
                                            value-key="value"
                                            v-on:input="clearParams"
                                            @select="handleSelect"
                            >
                            </ElAutocomplete>
                            <template #prefix>
                                Адрес регистрации
                            </template>
                        </ElFormItem>
                    </div>
                </section>
                <section class="step-three__form-section">
                    <h2 class="step-three__form-section-title">
                        О кредите
                    </h2>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="creditBalance"
                        >
                            <ElInput
                                v-model="propertyForm.creditBalance"
                                placeholder="Остаток кредита"
                                disabled
                            >
                                <template #prefix>
                                    Остаток кредита
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="manualAnnuity"
                            type="number"
                        >
                            <ElInput
                                v-model="propertyForm.manualAnnuity"
                                placeholder="Ежемесячный платеж"
                                @input="formatMoney"
                            >
                                <template #prefix>
                                    Ежемесячный платеж
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="disableCredit"
                        >
                            <ElCheckbox
                                v-model="propertyForm.disableCredit"
                                label="Нет кредитного договора"
                                @change="disableCreditHandler"
                            />
                        </ElFormItem>
                    </div>
                    <div
                        v-if="!propertyForm.disableCredit"
                        class="step-three__item form__item"
                    >
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="loanAgreementNumber"
                        >
                            <ElInput
                                v-model="propertyForm.loanAgreementNumber"
                                placeholder="Номер кредитного договора"
                            >
                                <template #prefix>
                                    Номер кредитного договора
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="credit_date"
                        >
                            <ElDatePicker
                                v-model="propertyForm.credit_date"
                                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                                type="date"
                                :placeholder="propertyForm.disableCredit ? 'Дата сделки' : 'Дата заключения кредитного договора'"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="{ firstDayOfWeek: 1 }"
                                @change="changeCreditDateHandler"
                            />
                            <span class="form__label">{{
                                    propertyForm.disableCredit ? 'Дата сделки' : 'Дата заключения кредитного договора'
                                }}</span>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="dateLoanStart"
                        >
                            <ElDatePicker
                                v-model="propertyForm.dateLoanStart"
                                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                                type="date"
                                placeholder="Дата начала договора страхования"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="{ disabledDate: (time) => getDisabledStartDate(time), firstDayOfWeek: 1 }"
                            />
                            <span class="form__label">Дата начала договора страхования</span>
                        </ElFormItem>
                    </div>
                </section>
                <section v-if="!isLifeTariff" class="step-three__form-section">
                    <h2 class="step-three__form-section-title">
                        Объект страхования
                    </h2>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="sameRegisteredAddress"
                        >
                            <ElCheckbox
                                v-model="propertyForm.sameRegisteredAddress"
                                label="Совпадает с адресом регистрации"
                                @change="sameRegistreredAddressHandler"
                            />
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="registrationObjectAddress"
                        >
                            <ElAutocomplete class="form__item"
                                            v-model="propertyForm.registrationObjectAddress"
                                            :fetch-suggestions="fetchAddressSuggestions"
                                            placeholder="Адрес объекта страхования"
                                            :trigger-on-focus="false"
                                            value-key="value"
                                            v-on:input="clearParamsObject"
                                            @select="handleSelectObject"
                            >
                            </ElAutocomplete>
                            <template #prefix>
                                Адрес объекта страхования
                            </template>
                            <i class="form__item-icon-lock" slot="suffix"></i>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="yearHouseBuilt"
                        >
                            <ElInput
                                v-model="propertyForm.yearHouseBuilt"
                                placeholder="Год постройки дома"
                                v-mask="{mask: '9{4}'}"
                            >
                                <template #prefix>
                                    Год постройки дома
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="numberFloorsHouse"
                        >
                            <ElInput
                                v-model="propertyForm.numberFloorsHouse"
                                placeholder="Этажность дома"
                                v-mask="{regex: '^[0-9]*'}"
                            >
                                <template #prefix>
                                    Этажность дома
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-three__item-col form__col"
                            prop="square"
                        >
                            <ElInput
                                v-model="propertyForm.square"
                                placeholder="Площадь"
                                type="number"
                            >
                                <template #prefix>
                                    Площадь
                                </template>
                                <i class="form__item-icon-lock" slot="suffix"></i>
                            </ElInput>
                        </ElFormItem>
                    </div>

                    <div
                        v-if="showSelectTypeHomePurchase"
                        class="step-three__item form__item">
                        <ElFormItem
                            class="step-one-form__item-col form__col"
                            prop="typeHomePurchase"
                        >
                            <ElSelect
                                v-model="propertyForm.typeHomePurchase"
                                placeholder="Тип покупки жилья"
                                :popper-append-to-body="false"
                                @change="(item) => formSelectHandler(item, 'typeHomePurchase')"
                                @blur="typeHomePurchaseBlurHandler"
                            >
                                <template #prefix>
                                    Тип покупки жилья
                                </template>
                                <ElOption
                                    v-for="(option, index) in typeHomePurchaseList"
                                    :key="index"
                                    :label="option.label"
                                    :value="option.value"
                                >
                                </ElOption>
                            </ElSelect>
                        </ElFormItem>
                    </div>

                    <div class="step-three__item form__item">
                        <ElFormItem
                            class="step-one-form__item-col form__col"
                            prop="wallMaterials"
                        >
                            <ElSelect
                                v-model="propertyForm.wallMaterials"
                                placeholder="Материал стен"
                                :popper-append-to-body="false"
                                @change="(item) => formSelectHandler(item, 'wallMaterials')"
                                @blur="MaterialBlurHandler"
                                v-if="!isHideMaterial"
                            >
                                <template #prefix>
                                    Материал стен
                                </template>
                                <ElOption
                                    v-for="(option, index) in wallMaterials"
                                    :key="index"
                                    :label="option.label"
                                    :value="option.value"
                                >
                                </ElOption>
                            </ElSelect>
                        </ElFormItem>
                    </div>
                </section>
                <section class="step-three__form-section">
                    <div v-if="!isPropertyTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy"/>
                                    <span class="tep-three__item-checkbox-text">
                    Оплатой страховой премии подтверждаю, что
                    <span style="color: #00a1b0;text-underline-offset: .1875rem;">
                      все вопросы
                    </span>
                    на которые я отвечал на сайте мне понятны, все указанные сведения, являются достоверными и
                    существенными. 
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div v-if="!isPropertyTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy2">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy2">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy2"/>
                                    <span class="tep-three__item-checkbox-text">
                    Обязуюсь письменно сообщать Страховщику обо всех изменениях данных в ответах.
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy3">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy3">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy3"/>
                                    <span class="tep-three__item-checkbox-text">
                    Ознакомлен и согласен с
                    <a v-if="useTitul" href="https://zettains.ru/upload/rules/zayavlenie-na-titulnoe-strahovanie.pdf"
                       target="_blank">
                      условиями ипотечного страхования
                    </a>
                    <a v-else href="https://zettains.ru/upload/rules/oferta-e-ipoteki.pdf" target="_blank">
                      условиями ипотечного страхования
                    </a>
                 
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy4">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy4">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy4"/>
                                    <span class="tep-three__item-checkbox-text">
                    Ознакомлен и согласен с
                   
                    <a href="https://zettains.ru/upload/all-kid/KID_PROP_SBER.pdf" target="_blank">
                      ключевым информационным документом
                    </a>
                    
                  
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div v-if="!isPropertyTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy5">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy5">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy5"/>
                                    <span class="tep-three__item-checkbox-text">
                    Ознакомлен и согласен с

                    <a href="https://zettains.ru/upload/rules/pravila-kis-na-sayt.pdf" target="_blank">
                      правилами страхования ипотеки
                    </a>
                    

                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div v-if="!isPropertyTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy6">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy6">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy6"/>
                                    <span class="tep-three__item-checkbox-text">
                    Ознакомлен и согласен с
                   
                   
                    <a href="https://zettains.ru/upload/pr-docs/%D0%A4%D0%BE%D1%80%D0%BC%D0%B0%20%D0%9F%D0%BE%D0%BB%D0%B8%D1%81%D0%B0%20%D0%B6%D0%B8%D0%B7%D0%BD%D0%B8.pdf?t=1782737257527"
                       target="_blank">
                      договором личного страхования
                    </a>
                  
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>
                    <div v-if="!isPropertyTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="personalPolicy7">
                            <ElCheckboxGroup v-model="propertyForm.personalPolicy7">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="personalPolicy7"/>
                                    <span class="tep-three__item-checkbox-text">
          
                     Подтверждаю достоверность данных в
                    <a href="https://zettains.ru/upload/pr-docs/Форма%20Анкеты%20о%20состоянии%20здоровья%20застрахованного.pdf?t=1782737851856"
                       target="_blank">
                      Анкете о состоянии здоровья застрахованного
                    </a>
                    . С ответственностью за предоставление недостоверных (ложных) сведений ознакомлен и согласен.
                </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>

                    <div v-if="!isLifeTariff" class="step-three__item form__item">
                        <ElFormItem class="step-three__item-col form__col" prop="mortgageInsuranceAgreement">
                            <ElCheckboxGroup v-model="propertyForm.mortgageInsuranceAgreement">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="mortgageInsuranceAgreement"/>
                                    <span class="tep-three__item-checkbox-text">
                    Я ознакомлен и согласен с
                    
                    <a href="https://zettains.ru/upload/rules/pravila-zaemschika-kredita-na-sayt.pdf" target="_blank">
                      правилами страхования заемщика кредита
                    </a>
                  </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>


                    <div class="step-three__item form__item" v-if="!isPropertyTariff">
                        <ElFormItem class="step-three__item-col form__col" prop="policeAgreement">
                            <ElCheckboxGroup v-model="propertyForm.policeAgreement">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="policeAgreement"/>
                                    <span class="tep-three__item-checkbox-text">
                    Я даю <a href="https://zettains.ru/upload/rules/Приложение 9_Согласие для покупки полиса на сайте.pdf">согласие</a> на обработку персональных данных в соответствии с <a
                                        href="https://zettains.ru/company/privacy/" target="_blank">политикой в отношении обработки персональных данных</a>
                  </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>

                    <div class="step-three__item form__item" v-if="!isLifeTariff">
                        <ElFormItem class="step-three__item-col form__col" prop="policeAgreement">
                            <ElCheckboxGroup v-model="propertyForm.policeAgreement">
                                <div class="step-three__item-checkbox">
                                    <ElCheckbox name="policeAgreement"/>
                                    <span class="tep-three__item-checkbox-text">
                    Я даю <a href="https://zettains.ru/upload/rules/Приложение 9_Согласие для покупки полиса на сайте.pdf">согласие</a> на обработку персональных данных в соответствии с <a
                                        href="https://zettains.ru/company/privacy/" target="_blank">политикой в отношении обработки персональных данных</a>
                  </span>
                                </div>
                            </ElCheckboxGroup>
                        </ElFormItem>
                    </div>

                </section>
            </ElForm>
        </div>
    </div>
</template>
<script>
import {numbersLengthFromString, matchesEmailRegex} from '@/utils/string-helpers';
import BaseButton from '@/components/ui/BaseButton';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import SvgIcon from "@/components/ui/SvgIcon.vue";
import {PHONE_LENGTH, PERSON_PASSPORT_LENGTH, DEPARTMENT_CODE_LENGTH} from "@/consts";
import {validationHandler} from "@/utils/validation";
import {calculatorEipoteka, getIssuedByPassport} from "@/api/routes/calculator-eipoteka";
import {fetchFioSuggestions, fetchAddressSuggestions, fetchPassportCodeSuggestions} from '@/utils/api-helpers';

export default {
    name: 'Step3',
    components: {
        SvgIcon,
        ResultCard,
        BaseButton,
    },
    props: {
        tariffs: Object,
        formData: Object,
        prepareData: Object,
        tariffType: String,
        resultId: Number,
        uralsibId: String,
        useTitul: Boolean,
    },
    data() {
        return {
            propertyForm: {
                fio: '',
                userName: '',
                userSurname: '',
                userPatronymic: '',
                birthDate: '12.12.1994',
                gender: 'Мужской',
                phone: '',
                email: '',
                height: 0,
                weight: 0,
                passportNumber: '',
                passportDate: '',
                departmentCode: '',
                issuedBy: '',
                registrationAddress: '',
                registrationAddressKladr: '',
                registrationKladrHouse: '',
                registrationApartmentNumber: '',

                registrationStreet: '',
                registrationHome: '',
                registrationIndex: '',
                registrationStructure: '',
                registrationFiasGuid: '',
                registrationFiasHouseGuid: '',

                creditBalance: '100 000 ₽',
                loanAgreementNumber: '',
                manualAnnuity: '',
                credit_date: '',
                dateLoanStart: '',
                sameRegisteredAddress: false,
                disableCredit: false,

                personalPolicy: [],
                personalPolicy2: [],
                personalPolicy3: [],
                personalPolicy4: [],
                personalPolicy5: [],
                personalPolicy6: [],
                personalPolicy7: [],
                mortgageInsuranceAgreement: [],
                policeAgreement: [],

                registrationObjectAddress: '',
                registrationObjectAddressKladr: '',
                registrationObjectKladrHouse: '',
                registrationObjectFlat: '',

                objectStreet: '',
                objectHome: '',
                objectIndex: '',
                objectStructure: '',
                objectFiasGuid: '',
                objectFiasHouseGuid: '',

                yearHouseBuilt: '',
                numberFloorsHouse: '',
                square: '',
                wallMaterials: '',

                typeHomePurchase: '',
            },
            rules: {
                fio: [
                    {required: true, message: 'Поле ФИО обязательно для заполнения', trigger: 'blur'},
                ],
                birthDate: [
                    {required: true, message: 'Поле дата рождения обязательно для заполнения', trigger: 'blur'},
                ],
                gender: [
                    {required: true, message: 'Поле пол обязательно для заполнения', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: 'Поле телефона обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.phoneLengthIsValid, `Номер телефона должен содержать ${PHONE_LENGTH} символов`, resolve),
                        trigger: 'blur'
                    },
                ],
                email: [
                    {required: true, message: 'Поле почты обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.emailFormatIsValid, 'Неверный формат электронной почты!', resolve),
                        trigger: 'blur'
                    },
                ],
                height: [
                    {required: true, message: 'Поле с ростом обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.heightIsValid, `Некорректное значение роста`, resolve),
                        trigger: 'blur'
                    },
                ],
                weight: [
                    {required: true, message: 'Поле с весом обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.weightIsValid, `Некорректное значение веса`, resolve),
                        trigger: 'blur'
                    },
                ],
                passportNumber: [
                    {
                        required: true,
                        message: 'Поле серия и номер паспорта обязательно для заполнения',
                        trigger: 'blur'
                    },
                    {
                        validator: (rule, val, resolve) => validationHandler(this.passportIsValid, `Данные должны содержать ${PERSON_PASSPORT_LENGTH} символов`, resolve),
                        trigger: 'blur'
                    },
                ],
                passportDate: [
                    {required: true, message: 'Поле дата выдачи обязательно для заполнения', trigger: 'blur'},
                ],
                departmentCode: [
                    {required: true, message: 'Поле код подразделения обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.departmentCodeIsValid, `Данные должны содержать ${DEPARTMENT_CODE_LENGTH} символов`, resolve),
                        trigger: 'blur'
                    },
                ],
                issuedBy: [
                    {required: true, message: 'Поле кем выдан обязательно для заполнения', trigger: 'blur'},
                ],
                registrationAddress: [
                    {required: true, message: 'Поле адреса обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.addressIsValid, this.addressError, resolve),
                        trigger: 'blur'
                    }
                ],
                creditBalance: [
                    {required: true, message: 'Поле остаток кредита обязательно для заполнения', trigger: 'blur'},
                ],
                loanAgreementNumber: [
                    {
                        required: true,
                        message: 'Поле номер кредитного договора обязательно для заполнения',
                        trigger: 'blur'
                    },
                ],
                manualAnnuity: [
                    {required: true, message: 'Поле ежемесячный платеж обязательно для заполнения', trigger: 'blur'},
                ],
                credit_date: [
                    {
                        required: true,
                        message: 'Поле дата заключения кредитного договора обязательно для заполнения',
                        trigger: 'blur'
                    },
                ],
                dateLoanStart: [
                    {
                        required: true,
                        message: 'Поле дата начала договора страхования договора обязательно для заполнения',
                        trigger: 'blur'
                    },
                    {
                        validator: (rule, val, resolve) => validationHandler(this.dateStartWithoutCredit, 'Дата начала договора не может быть меньше даты сделки', resolve),
                        trigger: 'blur'
                    }
                ],
                sameRegisteredAddress: [
                    {required: false},
                ],

                personalPolicy: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy2: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy3: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy4: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy5: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy6: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                personalPolicy7: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                mortgageInsuranceAgreement: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],
                policeAgreement: [
                    {type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change'},
                ],

                registrationObjectAddress: [
                    {required: true, message: 'Поле адреса обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.addressIsValidObject, this.addressErrorObject, resolve),
                        trigger: 'blur'
                    }
                ],
                yearHouseBuilt: [
                    {required: true, message: 'Поле год постройки дома обязательно для заполнения', trigger: 'blur'},
                ],
                numberFloorsHouse: [
                    {required: true, message: 'Поле этажность дома обязательно для заполнения', trigger: 'blur'},
                    {
                        validator: (rule, val, resolve) => validationHandler(this.numberFloorsHouseIsValid, this.numberFloorsHouseError, resolve),
                        trigger: 'blur'
                    }
                ],
                square: [
                    {required: true, message: 'Поле площадь обязательно для заполнения', trigger: 'blur'},
                ],
                wallMaterials: [
                    {
                        required: !this.getHideMaterial(),
                        message: 'Поле материал стен обязательно для заполнения',
                        trigger: 'blur'
                    },
                ],
                typeHomePurchase: [
                    {required: true, message: 'Поле тип покупки жилья обязательно для заполнения', trigger: 'blur'},
                ],

            },
            wallMaterials: [],
            typeHomePurchaseList: [],
            stepThreeSessionData: null,
        }
    },
    computed: {
        showSelectTypeHomePurchase() {
            return this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72'
                && this.uralsibId === this.prepareData.bankId
                && (this.tariffType === 'lifeAndProperty' || this.tariffType === 'property')
        },
        emailFormatIsValid() {
            return matchesEmailRegex(this.propertyForm.email);
        },
        phoneLengthIsValid() {
            return numbersLengthFromString(this.propertyForm.phone) >= PHONE_LENGTH
        },
        passportIsValid() {
            return numbersLengthFromString(this.propertyForm.passportNumber) >= PERSON_PASSPORT_LENGTH;
        },
        departmentCodeIsValid() {
            return numbersLengthFromString(this.propertyForm.departmentCode) >= DEPARTMENT_CODE_LENGTH;
        },
        heightIsValid() {
            return this.propertyForm.height > 0 && this.propertyForm.height <= 300;
        },
        weightIsValid() {
            return this.propertyForm.weight > 0 && this.propertyForm.weight <= 500;
        },
        allInsuranceCost() {
            const summ = this.tariffs.reduce((acc, current) => {
                if (current.isSelected) {
                    return acc + current.sumPrem;
                }
                return acc + (current.isSelected) ? current.sumPrem : 0;
            }, 0);
            return `${summ ? summ.toFixed(2) : 0} ₽`;
        },
        isPropertyTariff() {
            return this.tariffType === 'property';
        },
        isLifeTariff() {
            return this.tariffType === 'life';
        },
        fio() {
            return this.propertyForm.fio;
        },
        addressIsValid() {
            if (!!!this.propertyForm.registrationAddressKladr || !!!this.propertyForm.registrationKladrHouse) {
                return false;
            }
            return true;
        },
        numberFloorsHouseError() {
            if (!!!this.propertyForm.numberFloorsHouse) {
                return 'Поле обязательно для заполнения'
            }

            let floorInt = parseInt(this.propertyForm.numberFloorsHouse);

            if (
                floorInt <= 0
                || floorInt > 200
            ) {
                return 'Некорректное значение этажности дома';
            }

            return '';
        },
        numberFloorsHouseIsValid() {
            let floorInt = parseInt(this.propertyForm.numberFloorsHouse);

            if (
                floorInt <= 0
                || floorInt > 200
            ) {
                return false;
            }

            return true;
        },
        addressError() {
            if (!!!this.propertyForm.registrationAddressKladr || !!!this.propertyForm.registrationKladrHouse) {
                return 'Некорректный адрес, выберите адрес из списка';
            }
            return 'Поле обязательно для заполнения'
        },
        addressIsValidObject() {
            if (!!!this.propertyForm.registrationObjectAddressKladr || !!!this.propertyForm.registrationObjectKladrHouse) {
                return false;
            }
            if (
                !!!this.propertyForm.registrationObjectFlat
                && (this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72' || this.prepareData.objectTypeId === 'd8a6c323-2e6c-4921-abd9-7288a78d3f7d')
            ) {
                return false;
            }
            return true;
        },
        dateStartWithoutCredit() {
            if (!this.propertyForm.disableCredit) {
                return true;
            }

            if (
                !!!this.propertyForm.dateLoanStart
                && !!!this.propertyForm.credit_date
            ) {
                return true;
            }

            if (
                !!!this.convertDateFormat(this.propertyForm.dateLoanStart)
                && !!!this.convertDateFormat(this.propertyForm.credit_date)
            ) {
                return true;
            }

            let creditDate = new Date(this.convertDateFormat(this.propertyForm.credit_date));
            let loadDate = new Date(this.convertDateFormat(this.propertyForm.dateLoanStart));

            return loadDate > creditDate;
        },
        isHideMaterial() {
            return this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72'
                || this.prepareData.objectTypeId === '20b0955b-4b94-43f7-a2ab-63fd96606287';
        },
        addressErrorObject() {
            if (!!!this.propertyForm.registrationObjectAddressKladr || !!!this.propertyForm.registrationObjectKladrHouse) {
                return 'Некорректный адрес, выберите адрес из списка';
            }
            if (
                !!!this.propertyForm.registrationObjectFlat
                && (this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72' || this.prepareData.objectTypeId === 'd8a6c323-2e6c-4921-abd9-7288a78d3f7d')
            ) {
                return 'Некорректный адрес, не указан номер квартиры/комнаты';
            }
            return 'Поле обязательно для заполнения'
        },
        fetchFioSuggestions,
        fetchAddressSuggestions,
        fetchPassportCodeSuggestions,
    },
    methods: {
        convertDateFormat(dateString) {
            const parts = dateString.split('.');

            if (parts.length === 3) {
                const day = parts[0];
                const month = parts[1];
                const year = parts[2];

                return `${year}-${month}-${day}`;
            } else {
                '';
            }
        },
        getHideMaterial() {
            return this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72'
                || this.prepareData.objectTypeId === '20b0955b-4b94-43f7-a2ab-63fd96606287';
        },
        formatMoney() {
            let rawValue = this.propertyForm.manualAnnuity.replace(/[^0-9.]/g, '');
            const parts = rawValue.split('.');
            const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            let decimalPart = parts[1] ? '.' + parts[1].slice(0, 2) : '';
            if (rawValue.includes('.') && !!!decimalPart) {
                decimalPart = '.';
            }
            this.propertyForm.manualAnnuity = integerPart + decimalPart;
        },
        getDisabledStartDate(date) {
            let currentDay = Date.now();
            let maxLimitDay = new Date();
            let numberOfDaysToAdd = 45;
            maxLimitDay.setDate(maxLimitDay.getDate() + numberOfDaysToAdd);
            return date.getTime() < currentDay || date.getTime() > maxLimitDay.getTime();
        },
        getDisabledPassportDate(date) {
            let currentDay = Date.now();
            return date.getTime() > currentDay;
        },
        submitHandler(formEl) {
            formEl.validate(valid => {
                if (valid) {
                    this.$emit('step-three-submit', this.propertyForm);
                }
            })
        },
        formSelectHandler(data, formField) {
            this.propertyForm[formField] = data;
            this.$refs.propertyFormRef.validateField(formField);
        },
        MaterialBlurHandler() {
            this.$refs.propertyFormRef.validateField('wallMaterials');
        },
        typeHomePurchaseBlurHandler() {
            this.$refs.propertyFormRef.validateField('typeHomePurchase');
        },
        async getIssuedByHandler() {
            let data = await getIssuedByPassport(this.propertyForm.departmentCode);
            if (data?.result) {
                if (data?.response?.name?.length > 0) {
                    this.propertyForm.issuedBy = data.response.name
                }
            }
        },
        clearParams(val) {
            this.propertyForm.registrationKladrHouse = '';
            this.propertyForm.registrationAddressKladr = '';

            this.propertyForm.registrationStreet = '';
            this.propertyForm.registrationHome = '';
            this.propertyForm.registrationIndex = '';
            this.propertyForm.registrationStructure = '';
            this.propertyForm.registrationFiasGuid = '';
            this.propertyForm.registrationFiasHouseGuid = '';
        },
        clearParamsObject(val) {
            this.propertyForm.registrationObjectAddressKladr = '';
            this.propertyForm.registrationObjectKladrHouse = '';
            this.propertyForm.registrationObjectFlat = '';

            this.propertyForm.objectStreet = '';
            this.propertyForm.objectHome = '';
            this.propertyForm.objectIndex = '';
            this.propertyForm.objectStructure = '';
            this.propertyForm.objectFiasGuid = '';
            this.propertyForm.objectFiasHouseGuid = '';
        },
        handleSelect(item) {
            this.propertyForm.registrationKladrHouse = item.houseKladrId;
            this.propertyForm.registrationAddressKladr = item.kladrId;
            this.propertyForm.registrationApartmentNumber = !!item?.flat ? item.flat : '';

            this.propertyForm.registrationStreet = item.street ?? '';
            this.propertyForm.registrationHome = item.home ?? '';
            this.propertyForm.registrationIndex = item.index ?? '';
            this.propertyForm.registrationStructure = item.structure ?? '';
            this.propertyForm.registrationFiasGuid = item.fiasId ?? '';
            this.propertyForm.registrationFiasHouseGuid = item.fiasId ?? '';

            this.$refs.propertyFormRef.validateField('registrationAddress');
        },
        handleSelectIssuedByCode(item) {
            this.propertyForm.departmentCode = item.code;
            this.propertyForm.issuedBy = item.name;

            this.$refs.propertyFormRef.validateField('issuedBy');
            this.$refs.propertyFormRef.validateField('departmentCode');
        },
        handleSelectObject(item) {
            this.propertyForm.registrationObjectAddressKladr = item.kladrId;
            this.propertyForm.registrationObjectKladrHouse = item.houseKladrId;
            this.propertyForm.registrationObjectFlat = item.flat;

            this.propertyForm.objectStreet = item.street ?? '';
            this.propertyForm.objectHome = item.home ?? '';
            this.propertyForm.objectIndex = item.index ?? '';
            this.propertyForm.objectStructure = item.structure ?? '';
            this.propertyForm.objectFiasGuid = item.fiasId ?? '';
            this.propertyForm.objectFiasHouseGuid = item.fiasId ?? '';

            this.$refs.propertyFormRef.validateField('registrationObjectAddress');
        },
        sameRegistreredAddressHandler(val) {
            if (val) {
                this.propertyForm.registrationObjectAddressKladr = this.propertyForm.registrationAddressKladr;
                this.propertyForm.registrationObjectKladrHouse = this.propertyForm.registrationKladrHouse;
                this.propertyForm.registrationObjectAddress = this.propertyForm.registrationAddress;
                this.propertyForm.registrationObjectFlat = this.propertyForm.registrationApartmentNumber;

                this.propertyForm.objectStreet = this.propertyForm.registrationStreet;
                this.propertyForm.objectHome = this.propertyForm.registrationHome;
                this.propertyForm.objectIndex = this.propertyForm.registrationIndex;
                this.propertyForm.objectStructure = this.propertyForm.registrationStructure;
                this.propertyForm.objectFiasGuid = this.propertyForm.registrationFiasGuid;
                this.propertyForm.objectFiasHouseGuid = this.propertyForm.registrationFiasHouseGuid;

                this.$refs.propertyFormRef.validateField('registrationObjectAddress');
            }
        },
        disableCreditHandler(val) {
            if (val) {
                this.propertyForm.loanAgreementNumber = '0';
            } else {
                this.propertyForm.loanAgreementNumber = '';
            }
        },
        changeCreditDateHandler(val) {
            this.$refs.propertyFormRef.validateField('dateLoanStart');
        }
    },
    async mounted() {
        this.stepThreeSessionData = await calculatorEipoteka('getSessionData');
        if (!!!this.resultId) {
            this.resultId = this.stepThreeSessionData.resultId ?? 0;
        }
        this.$emit('update-result-id', this.resultId);
        this.propertyForm = {
            ...this.propertyForm,
            ...this.stepThreeSessionData.stepThree,
            creditBalance: this.formData.credit_balance,
            birthDate: this.formData.birth_date,
            credit_date: this.formData.credit_date,
            gender: this.formData.gender === 'F' ? 'женский' : 'Мужской',
        }
        const materialsResponseData = await calculatorEipoteka('getMaterialsAction');
        if (!materialsResponseData.result) {
            this.wallMaterials = []
        } else {
            this.wallMaterials = materialsResponseData.response;
        }
        const typeHomePurchaseResponseData = await calculatorEipoteka('getTypeHomePurchaseAction');
        if (!typeHomePurchaseResponseData.result) {
            this.typeHomePurchaseList = []
        } else {
            this.typeHomePurchaseList = typeHomePurchaseResponseData.response;
        }
    },
}
</script>
<style lang="scss" scoped>
.step-three {
    &__result {
        height: 100%;
    }

    &__form {
        &-section {
            &:not(:last-child) {
                margin-bottom: rem(24);
            }
        }
    }

    &__item {
        &-checkbox {
            @include text-props(16px, 19.36px);
            display: flex;
            @media #{$screen-small} {
                @include text-props(14px, 16.94px);
            }

            :deep(.tep-three__item-checkbox-text) {
                &:not(:first-child) {
                    padding-left: rem(8);
                }
            }
        }
    }
}
</style>
